var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H4C2.343 18 1 16.7465 1 15.2V4H16C17.657 4 19 5.25347 19 6.8V15.2C19 16.7465 17.657 18 16 18Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C16.3284 13 17 12.3284 17 11.5C17 10.6716 16.3284 10 15.5 10C14.6716 10 14 10.6716 14 11.5C14 12.3284 14.6716 13 15.5 13Z",
    fill: "url(#paint0_linear_1349_478)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1 2.89533 2.343 2 4 2H13C14.657 2 16 2.89533 16 4H1Z",
    fill: "url(#paint1_linear_1349_478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1349_478",
    x1: 15.5,
    y1: 10,
    x2: 15.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1349_478",
    x1: 8.5,
    y1: 2,
    x2: 8.5,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.1fe6340e3ff43c3acd2ead10d854db06.svg";
export { ForwardRef as ReactComponent };